import { sharedAtom } from '../utilities/jotai-utils';

export const whiteLabelThemeConfigState = sharedAtom('whiteLabelThemeConfig', null);
